import {whenElementIsInView} from '../helpers';

whenElementIsInView(
    '[data-fslightbox]',
    (inView) => {
        if (inView) {
            import('./index');
        }
    },
    true,
);
